import React from "react";
import "../Styles/ProductDetails.css";
import { Modal, Box, Typography, Button } from "@mui/material";

const ProductModal = ({ product, open, onClose }) => {
    if (!product) return null;

    return (
        <Modal open={open} onClose={onClose} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box className="modal-box" onClick={onClose}>
                <div className="modal-description-content" onClick={(e) => e.stopPropagation()}>
                    {/* Product Image */}
                    <div className="modal-image">
                        <img src={product.image} alt={product.name} />
                    </div>

                    {/* Product Details */}
                    <div className="modal-details">
                        <Typography className="label"><strong>Product Name:</strong></Typography>
                        <Typography variant="h5" className="product-title">{product.name}</Typography>

                        <Typography className="label"><strong>Category:</strong></Typography>
                        <Typography className="product-category">{product.category}</Typography>

                        <Typography className="label"><strong>Description:</strong></Typography>
                        <Typography className="product-description">{product.description}</Typography>

                        {/* Dosage Details */}
                        <div className="product-row">
                            <Typography className="label"><strong>Dosage:</strong></Typography>
                            <Typography className="value">{product.dosage}</Typography>
                        </div>

                        {/* Packaging Details */}
                        <div className="product-row">
                            <Typography className="label"><strong>Packaging:</strong></Typography>
                            <Typography className="value packaging">{product.Packaging}</Typography>
                        </div>
                    </div>
                </div>

                {/* Close Button Inside Modal */}
                <div className="close-button-container">
                    <Button className="close-button" onClick={onClose}>
                        Close
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ProductModal;
